import React from 'react';
import {ALL_REACTIONS} from "../../../model2/reaction/const";

type Props = {
    onSelect: callback;
}

export default function AddReaction_FavoriteReactions(props: Props) {

    const favoriteReactions = gd.modules.reactions.favoriteReactions

    return (
        <>
            {_.map(favoriteReactions, (reaction) => (
                <div className="ui5-control-button s-28 fs-18"
                     onClick={() => props.onSelect(reaction)} key={reaction}>
                    {ALL_REACTIONS[reaction]}
                </div>
            ))}
        </>)
}